export const clientLogbookTableData = {
    keys: ["code", "name", "display_name", "color", "text_color", "line", "order", "is_active", "created_at", "updated_at"],
    config: {
        code: {
            isVisible: true,
            label: "Logbook Code",
            class: "",
            searchKey: "client_logbooks.code",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "client_logbooks",
            commonSearchKey: "client_logbooks",
            commonSearchObjectKey: "code"
        },
        is_active: {
            isVisible: true,
            label: "Is Active?",
            class: "",
            searchKey: "client_logbooks.is_active",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "client_logbooks",
            commonSearchKey: "client_logbooks",
            commonSearchObjectKey: "is_active"
        },
        name: {
            isVisible: true,
            label: "Logbook Name",
            class: "reg-name",
            searchKey: "client_logbooks.name",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "client_logbooks",
            commonSearchKey: "client_logbooks",
            commonSearchObjectKey: "name"
        },
        display_name: {
            isVisible: true,
            label: "Display Name",
            class: "reg-name",
            searchKey: "client_logbooks.display_name",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "client_logbooks",
            commonSearchKey: "client_logbooks",
            commonSearchObjectKey: "display_name"
        },
        // consultancy: {
        //     isVisible: true,
        //     label: "Consultancy",
        //     class: "",
        //     searchKey: "consultancies.name",
        //     type: "object",
        //     hasWildCardSearch: true,
        //     hasSort: true,
        //     hasCommonSearch: true,
        //     getListTable: "consultancies",
        //     commonSearchKey: "consultancies",
        //     commonSearchObjectKey: "name"
        // },
        // client: {
        //     isVisible: true,
        //     label: "Client",
        //     class: "client-wid",
        //     searchKey: "clients.name",
        //     type: "object",
        //     hasWildCardSearch: true,
        //     hasSort: true,
        //     hasCommonSearch: true,
        //     getListTable: "client",
        //     commonSearchKey: "clients",
        //     commonSearchObjectKey: "name"
        // },
        color: {
            isVisible: true,
            label: "Color",
            class: "",
            searchKey: "client_logbooks.color",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "client_logbooks",
            commonSearchKey: "client_logbooks",
            commonSearchObjectKey: "color"
        },
        text_color: {
            isVisible: true,
            label: "Text Color",
            class: "",
            searchKey: "client_logbooks.text_color",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "client_logbooks",
            commonSearchKey: "client_logbooks",
            commonSearchObjectKey: "text_color"
        },
        line: {
            isVisible: true,
            label: "Line",
            class: "",
            searchKey: "client_logbooks.line",
            type: "number",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "client_logbooks",
            commonSearchKey: "client_logbooks",
            commonSearchObjectKey: "line"
        },
        order: {
            isVisible: true,
            label: "Order",
            class: "",
            searchKey: "client_logbooks.order",
            type: "number",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "client_logbooks",
            commonSearchKey: "client_logbooks",
            commonSearchObjectKey: "order"
        },
        created_at: {
            isVisible: true,
            label: "Created At",
            class: "",
            searchKey: "client_logbooks.created_at",
            type: "date",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "client_logbooks",
            commonSearchKey: "client_logbooks",
            commonSearchObjectKey: "created_at"
        },
        updated_at: {
            isVisible: true,
            label: "Updated At",
            class: "",
            searchKey: "client_logbooks.updated_at",
            type: "date",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "client_logbooks",
            commonSearchKey: "client_logbooks",
            commonSearchObjectKey: "updated_at"
        }
    },
    data: []
};
